import '../styles/Footer.css';
import logo from '../assets/img/logo-abbvie.png';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import ModalLeaveSite from './ModalLeaveSite';

function Footer() {
  const [show, setShow] = useState(false);
  const [modalLink, setModalLink] = useState('');

  const handleClose = () => setShow(false);
  const handleShow = (link) => {
    setModalLink(link);
    setShow(true);
  };

  return (
    <>
      <footer>
        <div className='site-footer tac'><img src={logo} alt='Abbvie - Après-traitement'/></div><br/>
        <div className="site-bottom tac">
          <div>
            <Link to={'/mentions-legales'}>Mentions légales</Link>
            <Link
              to={'https://www.abbvie.fr/politique-de-confidentialite.html?trackingSelection=Yes'}
              target='_blank'
              onClick={e => { e.preventDefault(); handleShow('https://www.abbvie.fr/politique-de-confidentialite.html?trackingSelection=Yes'); }}
            >Politique de confidentialité</Link>
            <Link
              to={'https://www.abbvie.fr/contactez-nous.html'}
              target='_blank'
              onClick={e => { e.preventDefault(); handleShow('https://www.abbvie.fr/contactez-nous.html'); }}
            >Contacter AbbVie</Link>
            <Link to={'/declaration-accessibilite'}>Déclaration d'accessibilité</Link>
          </div>
          <div className="tar"><span>FR-ONC-260008 – 02/2026</span></div>
        </div>
      </footer>
      <ModalLeaveSite show={show} handleClose={handleClose} link={modalLink} />
    </>
  )
}

export default Footer